<ng-container *ngIf="isShowEntryPage() else systemTemplate">
    <div style="width:100%;height:100%">
        <entry-page></entry-page>
    </div>
</ng-container>
<ng-template #systemTemplate>
    <div class="drag-boundary">
        <mm-page #mmPage>
            <mm-page-body>
                <router-outlet></router-outlet>
            </mm-page-body>
        </mm-page>
    </div>
</ng-template>